import HP from "../host";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const UserService = {
  register: async (body: object) => {
    return await api.post("/users/newuser", body);
  },

  login: async (body: object) => {
    return await api.post("/users/loginuser", body);
  },

  forgetPassword: async (body: object) => {
    return await api.post("/users/forget-password", body);
  },

  changePassword: async (body: object, token: string) => {
    return await api.post(`/users/forget-password-complete/${token}`, body);
  },

  verifyAccount: async (token: string) => {
    return await api.get(`/users/verify-account/${token}`);
  },

  updateProfile: async (body: FormData) => {
    return await api.postFormData(`/users/update-profile`, body, {
      method: "PUT",
    });
  },

  searchStudentsByUsername: async (username: string | null) => {
    return await api.get(`/users/searchStudentByUsername/${username}`);
  },

  searchInstructorsByUsername: async (username: string | null) => {
    return await api.get(`/users/searchInstructorByUsername/${username}`);
  },
};
export default UserService;
